import { render } from "./GestionView.vue?vue&type=template&id=90092c44"
import script from "./GestionView.vue?vue&type=script&lang=js"
export * from "./GestionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__